"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("../constants");

var _utils = require("../utils");

var _wallet = require("@ethersproject/wallet");

var _contracts = require("@ethersproject/contracts");

var providers = _interopRequireWildcard(require("@ethersproject/providers"));

var _jsSha = require("js-sha256");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ERC1271_ABI = ['function isValidSignature(bytes _messageHash, bytes _signature) public view returns (bytes4 magicValue)'];
var MAGIC_ERC1271_VALUE = '0x20c13b0b';

var isEthAddress = function isEthAddress(address) {
  return /^0x[a-fA-F0-9]{40}$/.test(address);
};

function getEthersProvider(chainId) {
  var network = providers.getNetwork(chainId);
  if (!network._defaultProvider) throw new Error("Network with chainId ".concat(chainId, " is not supported"));
  return network._defaultProvider(providers);
}

function getChainId(_x) {
  return _getChainId.apply(this, arguments);
}

function _getChainId() {
  _getChainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(provider) {
    var payload, chainIdHex;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            payload = (0, _utils.encodeRpcCall)('eth_chainId', []);
            _context.next = 3;
            return safeSend(payload, provider);

          case 3:
            chainIdHex = _context.sent;
            return _context.abrupt("return", parseInt(chainIdHex, 16));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getChainId.apply(this, arguments);
}

function getCode(_x2, _x3) {
  return _getCode.apply(this, arguments);
}

function _getCode() {
  _getCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(address, provider) {
    var payload, code;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            payload = (0, _utils.encodeRpcCall)('eth_getCode', [address, 'latest']);
            _context2.next = 3;
            return safeSend(payload, provider);

          case 3:
            code = _context2.sent;
            return _context2.abrupt("return", code);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getCode.apply(this, arguments);
}

function safeSend(_x4, _x5) {
  return _safeSend.apply(this, arguments);
}

function _safeSend() {
  _safeSend = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data, provider) {
    var send;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            send = (Boolean(provider.sendAsync) ? provider.sendAsync : provider.send).bind(provider);
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              send(data, function (err, result) {
                if (err) reject(err);else if (result.error) reject(result.error);else resolve(result.result);
              });
            }));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _safeSend.apply(this, arguments);
}

function createEthLink(_x6, _x7, _x8) {
  return _createEthLink.apply(this, arguments);
}

function _createEthLink() {
  _createEthLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(did, address, provider) {
    var opts,
        _ref,
        message,
        timestamp,
        hexMessage,
        payload,
        signature,
        proof,
        _args4 = arguments;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            opts = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : {};
            _ref = (0, _utils.getConsentMessage)(did, !opts.skipTimestamp), message = _ref.message, timestamp = _ref.timestamp;
            hexMessage = '0x' + Buffer.from(message, 'utf8').toString('hex');
            payload = (0, _utils.encodeRpcCall)('personal_sign', [hexMessage, address]);
            _context4.next = 6;
            return safeSend(payload, provider);

          case 6:
            signature = _context4.sent;
            proof = {
              version: 1,
              type: _constants.ADDRESS_TYPES.ethereumEOA,
              message: message,
              signature: signature,
              address: address
            };
            if (!opts.skipTimestamp) proof.timestamp = timestamp;
            return _context4.abrupt("return", proof);

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _createEthLink.apply(this, arguments);
}

function createErc1271Link(_x9, _x10, _x11, _x12) {
  return _createErc1271Link.apply(this, arguments);
}

function _createErc1271Link() {
  _createErc1271Link = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(did, address, provider, opts) {
    var res, chainId;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return createEthLink(did, address, provider, opts);

          case 2:
            res = _context5.sent;
            _context5.next = 5;
            return getChainId(provider);

          case 5:
            chainId = _context5.sent;
            return _context5.abrupt("return", Object.assign(res, {
              type: _constants.ADDRESS_TYPES.erc1271,
              chainId: chainId
            }));

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _createErc1271Link.apply(this, arguments);
}

function typeDetector(_x13) {
  return _typeDetector.apply(this, arguments);
}

function _typeDetector() {
  _typeDetector = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(address) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", isEthAddress(address) ? _constants.ADDRESS_TYPES.ethereum : false);

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _typeDetector.apply(this, arguments);
}

function isERC1271(_x14, _x15) {
  return _isERC.apply(this, arguments);
}

function _isERC() {
  _isERC = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(address, provider) {
    var bytecode;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return getCode(address, provider).catch(function () {
              return null;
            });

          case 2:
            bytecode = _context7.sent;
            return _context7.abrupt("return", bytecode && bytecode !== '0x' && bytecode !== '0x0' && bytecode !== '0x00');

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _isERC.apply(this, arguments);
}

function createLink(_x16, _x17, _x18, _x19, _x20) {
  return _createLink.apply(this, arguments);
}

function _createLink() {
  _createLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(did, address, type, provider, opts) {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            address = address.toLowerCase();
            _context8.next = 3;
            return isERC1271(address, provider);

          case 3:
            if (_context8.sent) {
              _context8.next = 7;
              break;
            }

            return _context8.abrupt("return", createEthLink(did, address, provider, opts));

          case 7:
            return _context8.abrupt("return", createErc1271Link(did, address, provider, opts));

          case 8:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _createLink.apply(this, arguments);
}

function validateEoaLink(_x21) {
  return _validateEoaLink.apply(this, arguments);
}

function _validateEoaLink() {
  _validateEoaLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(proof) {
    var recoveredAddr;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            recoveredAddr = (0, _wallet.verifyMessage)(proof.message, proof.signature).toLowerCase();

            if (!(proof.address && proof.address !== recoveredAddr)) {
              _context9.next = 5;
              break;
            }

            return _context9.abrupt("return", null);

          case 5:
            proof.address = recoveredAddr;

          case 6:
            return _context9.abrupt("return", proof);

          case 7:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _validateEoaLink.apply(this, arguments);
}

function validateErc1271Link(_x22) {
  return _validateErc1271Link.apply(this, arguments);
}

function _validateErc1271Link() {
  _validateErc1271Link = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(proof) {
    var provider, contract, message, returnValue;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            provider = getEthersProvider(proof.chainId);
            contract = new _contracts.Contract(proof.address, ERC1271_ABI, provider);
            message = '0x' + Buffer.from(proof.message, 'utf8').toString('hex');
            _context10.next = 5;
            return contract.isValidSignature(message, proof.signature);

          case 5:
            returnValue = _context10.sent;
            return _context10.abrupt("return", returnValue === MAGIC_ERC1271_VALUE ? proof : null);

          case 7:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _validateErc1271Link.apply(this, arguments);
}

function validateLink(_x23) {
  return _validateLink.apply(this, arguments);
}

function _validateLink() {
  _validateLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(proof) {
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (!(proof.type === _constants.ADDRESS_TYPES.ethereumEOA)) {
              _context11.next = 4;
              break;
            }

            return _context11.abrupt("return", validateEoaLink(proof));

          case 4:
            if (!(proof.type === _constants.ADDRESS_TYPES.erc1271)) {
              _context11.next = 6;
              break;
            }

            return _context11.abrupt("return", validateErc1271Link(proof));

          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _validateLink.apply(this, arguments);
}

function authenticate(_x24, _x25, _x26) {
  return _authenticate.apply(this, arguments);
}

function _authenticate() {
  _authenticate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(message, address, provider) {
    var hexMessage, payload, signature, recoveredAddr;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            if (address) address = address.toLowerCase();

            if (!provider.isAuthereum) {
              _context12.next = 3;
              break;
            }

            return _context12.abrupt("return", provider.signMessageWithSigningKey(text));

          case 3:
            hexMessage = '0x' + Buffer.from(message, 'utf8').toString('hex');
            payload = (0, _utils.encodeRpcCall)('personal_sign', [hexMessage, address]);
            _context12.next = 7;
            return safeSend(payload, provider);

          case 7:
            signature = _context12.sent;

            if (!address) {
              _context12.next = 12;
              break;
            }

            recoveredAddr = (0, _wallet.verifyMessage)(message, signature).toLowerCase();

            if (!(address !== recoveredAddr)) {
              _context12.next = 12;
              break;
            }

            throw new Error('Provider returned signature from different account than requested');

          case 12:
            return _context12.abrupt("return", "0x".concat((0, _jsSha.sha256)(signature.slice(2))));

          case 13:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _authenticate.apply(this, arguments);
}

var _default = {
  authenticate: authenticate,
  validateLink: validateLink,
  createLink: createLink,
  typeDetector: typeDetector,
  isERC1271: isERC1271
};
exports.default = _default;